module.exports = __webpack_public_path__ + "img/prev.e9b1b3ee.svg";